import { render } from "./AvenguerPage.vue?vue&type=template&id=ab33a582&scoped=true"
import script from "./AvenguerPage.vue?vue&type=script&lang=js"
export * from "./AvenguerPage.vue?vue&type=script&lang=js"

import "./AvenguerPage.vue?vue&type=style&index=0&id=ab33a582&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab33a582"]])

export default __exports__